<div class="cart">
  <div class="cart-body">
    <!-- Startup selection dropdown for Admin users -->
    <div class="form-group mb-3 col-md-6 col-lg-4" *ngIf="authService.isAdmin || authService.isTenantAdminOrOperator">
      <label>{{ 'PANEL.LMS.COMMON.SELECT_STARTUP' | translate }}</label>
      <p-dropdown [options]="dataStartups" [style]="{'min-width':'250px'}" [placeholder]="'PANEL.LMS.COMMON.SELECT_STARTUP_PLACEHOLDER' | translate"
        styleClass="w-100" optionLabel="title" optionValue="id" [(ngModel)]="selectedStartup" [filter]="true"
        [disabled]="loadingStartups" (onChange)="onStartupSelect()">
        <ng-template pTemplate="empty">
            <div class="p-3 text-center">
            <span *ngIf="loadingStartups">{{ 'PANEL.LMS.COMMON.LOADING_STARTUPS' | translate }}</span>
            <span *ngIf="!loadingStartups">{{ 'PANEL.LMS.COMMON.NO_STARTUPS' | translate }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <!-- Course/Program selection dropdown -->
    <div class="form-group mb-3 col-md-6 col-lg-3"
      *ngIf="dataCourse?.length>1 && (!(authService.isAdmin || authService.isTenantAdminOrOperator) || selectedStartup)">
      <label>{{ 'PANEL.LMS.COMMON.SELECT_PROGRAM' | translate }}</label>
      <p-dropdown [options]="dataCourse" [style]="{'min-width':'200px'}" [placeholder]="'PANEL.LMS.COMMON.SELECT_PROGRAM_PLACEHOLDER' | translate"
        styleClass=" w-100" optionLabel="courseName" optionValue="courseId" [(ngModel)]="courseId" [filter]="true"
        (onChange)="navigate()">
      </p-dropdown>
    </div>

    <!-- Message for Admin when no startup selected -->
    <div class="alert alert-info" *ngIf="(authService.isAdmin || authService.isTenantAdminOrOperator) && !selectedStartup && !loadingStartups">
      <i class="fas fa-info-circle me-2"></i>
      {{ 'PANEL.LMS.COMMON.ADMIN_MESSAGE' | translate }}
    </div>

    <ng-container *ngIf="!(authService.isAdmin || authService.isTenantAdminOrOperator) || selectedStartup">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" [activeId]="fragment" (activeIdChange)="tabChanged($event)">
        <li ngbNavItem="modules">
          <button ngbNavLink>{{ 'PANEL.LMS.TABS.MODULES' | translate }}</button>
          <ng-template ngbNavContent>
            <app-module-list [course]="courseInformation" [teachers]="teachers" [loading]="loading">
            </app-module-list>
            <p-message severity="warn" [text]="'PANEL.LMS.COMMON.NOT_CONNECTED' | translate"
              *ngIf="!courseInformation && !loading"></p-message>
          </ng-template>
        </li>
        <li ngbNavItem="assignments">
          <button ngbNavLink>{{ 'PANEL.LMS.TABS.ASSIGNMENTS' | translate }}</button>
          <ng-template ngbNavContent>
            <app-assignments [courseId]="courseInformation?.id" *ngIf="courseInformation" [loading]="loading">
            </app-assignments>
            <p-message severity="warn" [text]="'PANEL.LMS.COMMON.NOT_CONNECTED' | translate"
              *ngIf="!courseInformation && !loading"></p-message>
          </ng-template>
        </li>
        <li ngbNavItem="announcements">
          <button ngbNavLink>{{ 'PANEL.LMS.TABS.ANNOUNCEMENTS' | translate }}</button>
          <ng-template ngbNavContent>
            <app-announcements></app-announcements>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="nav"></div>
    </ng-container>
  </div>
</div>